import { setCurrentLocale, setDefault24HourClock, setDefaultDateFormat, setDefaultTimezone } from './utils';
import assetResolver from '../services/assetResolverService';
import frontendStore from './frontendStore';

export interface ICommonFrontend {
  init(store: any): void;
}

const commonFrontend: ICommonFrontend = {
  init(store: any) {
    const initialState = store.getState();

    frontendStore.init(store);

    assetResolver.setAssets(initialState.siteConfig.assetsBaseUri, initialState.siteConfig.assetManifest);

    setCurrentLocale(initialState.localeConfig.code);

    if (initialState.auth) {
      if (initialState.auth.timezone) {
        setDefaultTimezone(initialState.auth.timezone);
      }
      setDefault24HourClock(initialState.auth.is_time_24hr);
      setDefaultDateFormat(initialState.auth.date_format);
    }
  }
};

export default commonFrontend;
